import React from "react";
import { useTranslation } from "react-i18next";

const AboutHeroSection = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto p-4 lg:px-16 bg-[#F5E49D]">
      <section
        className="relative min-h-[90vh] flex items-center rounded-2xl my-8 overflow-hidden bg-cover bg-center"
        style={{
          backgroundImage: "url(/images/abouthero.jpg)",
        }}
      >
        <div className="absolute inset-0 bg-black/50 z-10"></div>
        <div className="max-w-3xl px-4 relative lg:ps-20 z-20 text-white">
          <div className="space-y-8">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold leading-[1.5]">
              {t("aboutHero.title")}
            </h1>

            <p className="text-lg md:text-xl max-w-5xl leading-[1.8]">
              {t("aboutHero.subtitle")}
            </p>

            <button
              onClick={() =>
                window.open("viber://chat?number=+959791602729", "_blank")
              }
              className="bg-[#fff] text-black text-base font-semibold py-4 px-8 rounded-2xl hover:bg-[#e6d088] hover:-translate-y-0.5 hover:shadow-lg transition-all duration-300"
            >
              {t("aboutHero.button")}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutHeroSection;
